import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';
import { CouponEditWrap } from '../../views/coupon-v2/save/CouponSaveWrap';

const CouponEdit = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_EDIT}>
      <CouponEditWrap />
    </PageTemplate>
  );
};

export default CouponEdit;
